import request from '@/CommonDP/utils/request';
export default {

  queryFolderTemplateTree(folderTemplateTypeId) {
    const category = folderTemplateTypeId || "";
    return request.get(`/admin/folderTemplate/list?folderTemplateTypeId=` + category);
  },

  queryFilteredTemplateTree(prjSubType) {
    return request.get(`/admin/folderTemplate/filterByPrjSubType?prjSubType=${prjSubType || ""}`);
  },

  create(form) {
    return request.post(`/admin/folderTemplate/batchAdd`, form);
  },
  moveUp(folderId) {
    return request.post(`/admin/folderTemplate/moveUp?folderId=${folderId}`);
  },
  moveDown(folderId) {
    return request.post(`/admin/folderTemplate/moveDown?folderId=${folderId}`);
  },
  upgradeLevel(folderId) {
    return request.post(`/admin/folderTemplate/upgradeLevel?folderId=${folderId}`);
  },
  downGradeLevel(folderId) {
    return request.post(`/admin/folderTemplate/downGradeLevel?folderId=${folderId}`);
  },
  deleteFolder(folderId) {
    return request.post(`/admin/folderTemplate/delete?folderId=${folderId}`);
  },
  rename(json) {
    return request.post(`/admin/folderTemplate/rename`, json);
  },

  bindToArchiveFolder(folderId, archiveFolderId) {
    return request.post(`/admin/folderTemplate/archiveFolder/bind?folderId=${folderId}&archiveFolderId=${archiveFolderId}`);
  },

  batchSetArchiveFileKind(folderIds, archiveFileKind) {
    return request.post(`/admin/folderTemplate/archiveFolder/setFolderKind`, {
      folderIds, archiveFileKind
    });
  }
};
